import { customAlphabet } from 'nanoid';
export function nanoid(
  alphabet: string = '1234567890abcdef',
  size: number = 10
) {
  return customAlphabet(alphabet, size)();
}
